import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, confirmPasswordReset, verifyPasswordResetCode } from 'firebase/auth';
import logoImg from '../img/newlogo.png';

function ResetPassword() {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [resultMessage, setResultMessage] = useState(null);
    const [email, setEmail] = useState('');
    const [actionCode, setActionCode] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Extraer todos los parámetros necesarios de la URL
        const urlParams = new URLSearchParams(location.search);
        const oobCode = urlParams.get('oobCode');
        const mode = urlParams.get('mode');

        if (mode === 'resetPassword' && oobCode) {
            setActionCode(oobCode);
            // Verificar el código y obtener el email
            const auth = getAuth();
            verifyPasswordResetCode(auth, oobCode)
                .then((email) => {
                    setEmail(email);
                })
                .catch((error) => {
                    console.error('Error verificando código:', error);
                    setResultMessage({
                        status: 'error',
                        message: 'El enlace no es válido o ha expirado.'
                    });
                });
        } else {
            setResultMessage({
                status: 'error',
                message: 'URL de restablecimiento de contraseña inválida.'
            });
        }
    }, [location]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setResultMessage(null);

        if (newPassword !== confirmPassword) {
            setResultMessage({
                status: 'error',
                message: 'Las contraseñas no coinciden.'
            });
            return;
        }

        if (newPassword.length < 6) {
            setResultMessage({
                status: 'error',
                message: 'La contraseña debe tener al menos 6 caracteres.'
            });
            return;
        }

        try {
            const auth = getAuth();
            await confirmPasswordReset(auth, actionCode, newPassword);

            setResultMessage({
                status: 'success',
                message: 'Tu contraseña ha sido actualizada correctamente.'
            });

            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (error) {
            console.error('Error al restablecer contraseña:', error);
            setResultMessage({
                status: 'error',
                message: 'Error al restablecer la contraseña. Por favor, intenta nuevamente.'
            });
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <img src={logoImg} alt="Logo" className="login-logo" />
                <h2>Restablece tu contraseña</h2>
                {email && <p className="email-display">de {email}</p>}

                <form onSubmit={handleSubmit} className="login-form">
                    <input
                        type="password"
                        placeholder="Nueva contraseña"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        className="login-input"
                        required
                    />
                    <input
                        type="password"
                        placeholder="Confirmar contraseña"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="login-input"
                        required
                    />
                    <button type="submit" className="login-button">
                        Guardar nueva contraseña
                    </button>
                </form>

                <button
                    onClick={() => navigate('/login')}
                    className="back-button"
                >
                    Volver al inicio de sesión
                </button>

                {resultMessage && (
                    <div
                        className={`message ${resultMessage.status}`}
                        dangerouslySetInnerHTML={{ __html: resultMessage.message }}
                    />
                )}
            </div>
        </div>
    );
}

export default ResetPassword; 